


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AddChargeAccountModel } from '@/models/accounting/accountreceivable';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { accountReceivableService, storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class VehicleCapture extends Base {
  public dataCaptured: boolean = false;
  public addAccountModel: AddChargeAccountModel = {
    accountNumber: '',
    customerTypeNumber: '',
    id: 0,
    name: '',
    store: {},
    storeId: 0,
    storeName: '',
  };
  public storeId: number = 0;
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public disableSubmitButton: boolean = false;

  public created(): void {
    this.storeId = Number(this.$route.params.storeId);
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.chargecustomeraccounts',
        params: { storeId: this.storeId.toString() },
      });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.addAccount();
    }
    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('chargeAccount.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('chargeAccount.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'chargeAccount');
    
    this.storeId = Number(this.$route.params.storeId);

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.getStores();
    if (this.$route.params.id) {
      this.getAccountDetails();
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'storeName',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'chargeAccount.chargeAccountFields.storeName'
          ) as string,
          required: true,
          disabled: true,
          loading: false,
          rules:[
            v => this.required('Store Name',v)
          ]
        },
      },
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t('chargeAccount.chargeAccountFields.name') as string,
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v => this.required('Name',v)
          ]
        },
      },
      {
        key: 'customerTypeNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'chargeAccount.chargeAccountFields.customerTypeNumber'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v => this.required('Customer Type Number',v)
          ]
        },
      },
      {
        key: 'accountNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'chargeAccount.chargeAccountFields.accountNumber'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v => this.required('Account Number',v)
          ]
        },
      },
    ];
  }

  public validateAddAcount(): Vue & { validate: () => boolean } {
    return this.$refs.addAccountForm as Vue & { validate: () => boolean };
  }

  public async addAccount(): Promise<void> {
    if(this.validateAddAcount().validate()){
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.$validator.validateAll()) {
          await accountReceivableService.addAccountAsync(
            this.addAccountModel,
            this.storeId
          );
          this.showAlert(true, this.$t('chargeAccount.alertSaveChargeAccount'));
          this.$router.push({
            name: 'admin.chargecustomeraccounts',
            params: { storeId: this.storeId.toString() },
          });
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public async getStores(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const stores = await storeService.getStoresList();
      this.setStoreName(stores.results);
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
  public setStoreName(stores: any[]) {
    stores.forEach((store) => {
      if (store.id === this.storeId.toString()) {
        this.addAccountModel.storeId = store.id;
        this.addAccountModel.storeName = store.dealershipName;
      }
    });
  }
  public async getAccountDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const account = await accountReceivableService.getAccountAsync(
        Number(this.$route.params.id),
        this.storeId
      );
      this.addAccountModel = account;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public backToList() {
    this.$router.push({ name: 'admin.chargecustomeraccounts' });
  }
}
